import { IMenuLink } from 'interfaces/menu-link.interface';
import { SET_MENU_LINKS, SetMenuLinks } from './types';

export const setMenuLinks = (payload: IMenuLink[]): SetMenuLinks => ({
  type: SET_MENU_LINKS,
  payload,
});
